module.exports = __webpack_public_path__ + "static/img/more.453c6ccc.svg";